<template>
  <v-row class="my-2">
    <v-col class="py-1" cols="12" sm="6" md="4" lg="4">
      <DenseActionCard title="Mes transactions" description="Historique de mes transactions pour cet événement"
        icon="mdi-receipt" :toPage="{ name: 'Historique' }"></DenseActionCard>
    </v-col>
    <v-col class="py-1" cols="12" sm="6" md="4" lg="4">
      <DenseActionCard title="Nouvelle inscription" description="Inscrire un nouveau participant à cet événement"
        icon="mdi-account-plus" :toPage="{ name: 'Home' }"></DenseActionCard>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
